/**
 * Tuile chiffrée de la charte (maquettes 18a « Suivi chiffré », 18b « Comptage cuisine ») : sur-titre en
 * capitales, grand nombre en tabular-nums, unité, note facultative — dans le ton d'état demandé.
 */
type Ton = 'neutre' | 'info' | 'succes' | 'attention' | 'danger';

const TON: Record<Ton, { boite: string; label: string; valeur: string }> = {
    neutre: { boite: 'bg-surface-soft border-border-soft', label: 'text-content-muted', valeur: 'text-content' },
    info: { boite: 'bg-state-info-soft border-state-info/30', label: 'text-state-info', valeur: 'text-state-info' },
    succes: { boite: 'bg-state-ok-soft border-state-ok/30', label: 'text-state-ok', valeur: 'text-state-ok' },
    attention: { boite: 'bg-state-warn-soft border-state-warn/30', label: 'text-state-warn', valeur: 'text-state-warn' },
    danger: { boite: 'bg-state-danger-soft border-state-danger/30', label: 'text-state-danger', valeur: 'text-state-danger' },
};

export interface Tuile { label: string; valeur: string | number; unite?: string; ton: Ton; note?: string }

export function TuileChiffre({ t, grande }: { t: Tuile; grande?: boolean }) {
    const c = TON[t.ton];
    return (
        <div className={`px-[13px] py-3 rounded-[10px] border ${c.boite}`}>
            <div className={`text-[9.5px] font-bold uppercase tracking-[.05em] leading-[1.3] ${c.label}`}>{t.label}</div>
            <div className="flex items-baseline gap-1 mt-[7px]">
                <span className={`${grande ? 'text-[24px]' : 'text-[23px]'} font-bold tracking-[-0.02em] tabular-nums leading-none ${c.valeur}`}>{t.valeur}</span>
                {t.unite && <span className={`text-[11px] ${c.label}`}>{t.unite}</span>}
            </div>
            {t.note && <p className={`mt-2 text-[11px] leading-[1.45] text-pretty ${c.label}`}>{t.note}</p>}
        </div>
    );
}
